var dropdownSeparator = 'fx_2d2fb1e5_cwygty0';

export { dropdownSeparator };
//# sourceMappingURL=separator.vanilla.mjs.map
